import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { ShipmentStatus } from '@/features/shipment/domain/enums/ShipmentStatus'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class ShipmentTrackFilterEntity {
  regions?: RegionMiniEntity[]
  shipmentStatuses?: Array<ShipmentStatus>
  fetchAll?: boolean
  channels?: ChannelMiniEntity[]
}
